(ns very.http.specs
  (:require
    [cljs.spec.alpha :as s]
    [very.re-frame.specs :as reframe]
    )
  )

;; @TODO figure out namespacing- how do we preserve the ::query/query
(s/def ::query (s/and string? #(not (empty? %))))
(s/def ::variables (s/nilable map?))
(s/def ::operation-name (s/and string? #(not (empty? %))))
(s/def ::gql (s/keys :req-un [::query
                              ::operation-name]
                     :opt-un [::variables]))
(s/def ::success ::reframe/dispatch-vector)
(s/def ::failure ::reframe/dispatch-vector)
(s/def ::error ::reframe/dispatch-vector)
(s/def ::uri string?)
(s/def ::allow-unauth? true?)
(s/def ::cancellable? boolean?)
(s/def ::timeout pos-int?)
(s/def ::name keyword?)

(s/def ::graphql (s/keys :req-un [::gql
                                  ::success]
                         :opt-un [::failure
                                  ::error
                                  ::uri
                                  ::allow-unauth?
                                  ::cancellable?
                                  ::timeout
                                  ::name]))

(s/def ::spec (s/or :single ::graphql
                    :multiple (s/coll-of ::graphql
                                         :kind vector?
                                         :min-count 1)))
